import React, {useEffect, useState} from 'react';
import {Box, Grid, Typography} from '@deere/fuel-react';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {ChartsGraphs} from "@deere/ux.uxframe-react";
import {NO_RESPONSES} from "../shared/Constants";

export const SummaryOptions = ({classes, feedbackList, item}) => {
    const [comments, setComments] = useState([])
    const [responses, setResponses] = useState([])
    const [noOfYes, setNoOfYes] = useState([])
    const [totalYesOrNo, setTotalYesOrNo] = useState([])
    const [chartData, setChartData] = useState({})

    useEffect(() => {
        const noOfYesResponses = feedbackList.filter(item => item.feedback.notApplicable === false && item.feedback.yesNoChoice === "Y").length
        const noOfNoResponses = feedbackList.filter(item => item.feedback.notApplicable === false && item.feedback.yesNoChoice === "N").length
        const yesOrNoResp = feedbackList.filter(item => item.feedback.notApplicable === false && (item.feedback.yesNoChoice === "N" || item.feedback.yesNoChoice === "Y")).length
        setComments(feedbackList.filter(item => item.feedback.comment !== ""))
        setResponses(feedbackList.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.yesNoChoice !== ""))
        setNoOfYes(noOfYesResponses)
        setTotalYesOrNo(yesOrNoResp)
        setChartData({
            labels: ["Yes", "No"],
            datasets: [{
                data: [noOfYesResponses, noOfNoResponses],
                backgroundColor: ["#006400", "#FFDE00"],
                borderWidth: [0, 0]
            }]
        })
        return () => {
            setComments([])
        }
    }, [feedbackList]);

    return (
        <Grid container>
            <Grid item xs={12} md={10}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{
                        expandIcon: classes.expandIcon,
                        content: classes.content,
                        expanded: classes.expanded
                    }}
                    expandIcon={<ExpandMoreIcon
                        style={{fontSize: '2rem'}}/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography
                                color="primary" size="md">
                                    {item.subCategory ? item.subCategory.description + ' : ' : ''}
                                    {item.criteria}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography color="tertiary" size="sm">
                                {responses.length} / {feedbackList.length} Responses, {comments.length} Comments
                            </Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
            </Grid>
            <Grid item xs={12} md={2}>
                {responses.length > 0 ?
                    <Box display="flex"
                         justifyContent="flex-end"
                         p="1rem">
                        <ChartsGraphs
                            type="pie"
                            data={chartData}
                            height={25} width={25}
                            id={item.id}
                            redraw={false}
                            options={{
                                legend: {
                                    display: false
                                }
                            }}
                        />
                        <Typography size="md"
                                    fontWeight="regular"
                                    component="p"
                                    display="inline">
                            &nbsp; {noOfYes}/{totalYesOrNo} Yes
                        </Typography>
                    </Box> :
                    <Box display="flex"
                         justifyContent="flex-end"
                         p="1rem">
                        <Typography size="md" fontWeight="bold"
                                    component="p"
                                    display="inline">
                            {NO_RESPONSES}
                        </Typography>
                    </Box>}
            </Grid>
        </Grid>
    )
}